import './TableInputField.scss';
import { ChangeEventHandler, ClipboardEventHandler } from 'react';
import { Form } from 'react-bootstrap';

interface TableInputFieldProps {
  value?: string | number;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onPaste: ClipboardEventHandler<HTMLInputElement>;
  type?: string;
  elementId?: string;
  dataTestId?: string;
}

export const TableInputField = ({
  value,
  onChange,
  onPaste,
  elementId,
  type = 'number',
  dataTestId
}: TableInputFieldProps) => (
  <Form.Group id={elementId} className='table-input-field-group'>
    <Form.Control
      type={type}
      value={value ?? ''}
      onChange={onChange}
      onPaste={onPaste}
      data-testid={dataTestId}
    />
  </Form.Group>
);
